export enum motionSensorAmpModes {
    low = 'low',
    belowAverage = 'belowAverage',
    medium = 'medium',
    aboveAverage = 'aboveAverage',
    high = 'high',
}
